import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { LogoImage } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("rdp_admin_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#030712] px-5">
      <div className="absolute inset-0 hero-glow" />
      <form onSubmit={submit}
        className="relative glass-card rounded-2xl p-8 sm:p-10 w-full max-w-md">
        <div className="flex justify-center mb-6"><LogoImage className="h-14" /></div>
        <h1 className="font-display text-2xl font-bold text-center text-slate-50">Admin Dashboard</h1>
        <p className="mt-2 text-sm text-center text-slate-400">Authorized administrators only.</p>
        <div className="mt-7 space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-300 mb-1.5" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} autoComplete="username"
              className="w-full rounded-lg bg-slate-900/70 border border-white/10 px-4 py-2.5 text-sm text-slate-100 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-300 mb-1.5" htmlFor="admin-password">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
              className="w-full rounded-lg bg-slate-900/70 border border-white/10 px-4 py-2.5 text-sm text-slate-100 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-xs text-red-400">{error}</p>}
          <button type="submit" data-testid="admin-login-btn" disabled={loading}
            className="w-full rounded-full bg-blue-600 py-3 text-sm font-semibold text-white transition-all hover:bg-blue-500 disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 className="animate-spin" size={15} />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
